import { create } from 'zustand';
import { RequestStatus } from '@/shared/model/requestStatus';
import { chatService } from '@/entities/Chat/api/chatService';
import type { AppChatDetailsData, AppChatDetailsActions } from './types';

/** Создаёт состояние сведений собеседника с защитой от смены диалога */
export const createAppChatDetailsStore = () => {
    let revision = 0;

    const initial: AppChatDetailsData = {
        data: null,
        status: RequestStatus.Idle,
        error: null
    };

    return create<AppChatDetailsData & AppChatDetailsActions>((set) => ({
        ...initial,

        load: async (id, role) => {
            const current = ++revision;

            set({
                ...initial,
                status: RequestStatus.Loading
            });

            try {
                const data = await chatService.getUserInfo(id, role);

                if (current !== revision) return;

                set({
                    data,
                    status: RequestStatus.Success
                });
            } catch {
                if (current !== revision) return;

                set({
                    error: 'Не удалось загрузить сведения собеседника',
                    status: RequestStatus.Error
                });
            }
        },

        reset: () => {
            revision += 1;
            set(initial);
        },
    }));
};
